import { Card, CardBody, Col, Container, Form, Row } from 'reactstrap'
import { AddPost, Blog, BlogDiscardButton, BlogPostButton, PostEdit } from '../../../../utils/Constant'
import { Btn } from '../../../../AbstractElements'
import FormPost from './FormPost'
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs/Breadcrumbs'
import CardHeaderCommon from '../../../../CommonElements/CardHeaderCommon/CardHeaderCommon'
import CommonFileUpload from '../../../Common/CommonFileUpload'

const AddPostContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={AddPost} parent={Blog} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeaderCommon title={PostEdit} />
              <CardBody className="add-post">
                <FormPost />
                <Form>
                  <CommonFileUpload multiple />
                </Form>
                <div className="btn-showcase text-end">
                  <Btn color="primary">{BlogPostButton}</Btn>
                  <Btn color="light" type="reset">
                    {BlogDiscardButton}
                  </Btn>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AddPostContainer